import memoize from 'lodash/memoize';
import mapValues from 'lodash/mapValues';
import parseBoolean from '../../../utils/parse/parseBoolean';
import camelCase from '../../../utils/string/camelCase';

export default (styles, fallBackStyleKey = '') =>
  memoize((styleKey = '') =>
    mapValues(
      styles[camelCase(styleKey)] || styles[camelCase(fallBackStyleKey)] || {},
      parseBoolean,
    ),
  );
